module.exports = __webpack_public_path__ + "static/media/horizontal-align-right.a7906afe.svg";